/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
/**
 * Import Component
 */
import Carousel from '../../components/Carousel'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Carousel)))



// WEBPACK FOOTER //
// ./src/containers/components/Carousel.js